export const GOOGLE_OAUTH_NAME = 'google_oauth2';
export const REQUIRED_AUTH_FIELD = 'terms_acceptance';
export const IS_GOOGLE_AUTH_HIDDEN = false;
